import Box from "@mui/material/Box";
import { resource } from "../../utility/constants/resource/resource";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { useState, useEffect } from "react";

const ProfileView = () => {
  document.title = "Prakash | Profile";
  const [hasWelcome, setWelcome] = useState(
    sessionStorage.getItem("hasWelcome") ?? true
  );
  const onClickClose = () => {
    setWelcome(false);
  };
  useEffect(() => {
    sessionStorage.setItem("hasWelcome", `${hasWelcome}`);
  }, [hasWelcome]);

  const style = {
    borderLeft: `8px solid ${resource.colors.borderOutlineColor}`,
    padding: 3,
    backgroundColor: "#F6FAFF",
    color: "#4E4E4E",
    margin: 0.5,
    textAlign: "left",
  };
  return (
    <Box
      sx={{
        fontSize: 16,
        fontFamily: "Roboto, sans-serif",
      }}
    >
      {hasWelcome === true && (
        <Box
          sx={{
            textAlign: "left",
            borderTop: `8px solid #DEFDC2`,
            padding: 3,
            backgroundColor: "#F6FAFF",
            color: "#4E4E4E",
            position: "relative",
          }}
        >
          <IconButton
            onClick={onClickClose}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
            }}
          >
            <CloseIcon sx={{ height: 16, width: 16 }} />
          </IconButton>
          <Box
            sx={{
              fontSize: 18,
              color: "#005FA4",
            }}
          >
            <p>Thanks for visiting my personal page !!!</p>
            <p>Wish you a good day.</p>
          </Box>
        </Box>
      )}
      <Box
        sx={{
          border: `0.3px solid ${resource.colors.borderOutlineColor}`,
          borderRadius: 4,
          padding: 1,
          margin: 0.5,
          color: "#4E4E4E",
        }}
      >
        <Box>
          <Box sx={{ ...style }}>
            I am a software engineer, currently residing in Pune, India.
          </Box>
          <Box sx={{ ...style }}>
            Interested in Software development, mainly, in .NET stack and Azure.{" "}
            <br />
            <small>
              <i>
                If interested, please visit my{" "}
                <a href="https://github.com/pbesra">github profile</a>.
              </i>
            </small>
          </Box>
          <Box sx={{ ...style }}>
            Have previously worked on React based applications.
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default ProfileView;
